import React from 'react';
import type IssueTypeScreenSchemesPage from '@jira/admin-pages__issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypeScreenSchemesPage = lazyForPaint<typeof IssueTypeScreenSchemesPage>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-issue-type-screen-schemes-page", jiraSpaEntry: "async-jira-admin-pages-issue-type-screen-schemes-page" */ '@jira/admin-pages__issue-type-screen-schemes-page/src/IssueTypeScreenSchemesPage.tsx'
		),
	),
);

const AsyncIssueTypeScreenSchemesPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueTypeScreenSchemesPage}
		pageId="jira-admin-pages-issue-type-screen-schemes-page"
		shouldShowSpinner
	/>
);

export default AsyncIssueTypeScreenSchemesPage;
